module.exports = __webpack_public_path__ + "static/media/MIAB9945-180731-136_Small.ffb09e0d.jpg";